import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { YearMonth } from '@wilson/interfaces';
import { DateTimeFormat } from '@wilson/utils';
import { format } from 'date-fns';

@Injectable()
export class WorkingTimeDashboardContextService {
  readonly monthYear = signal<YearMonth>(
    format(new Date(), DateTimeFormat.MonthFormat) as YearMonth,
  );
  readonly refreshTrigger = signal(0);

  readonly monthYear$ = toObservable(this.monthYear);
  readonly refreshTrigger$ = toObservable(this.refreshTrigger);

  setMonthYear(value: YearMonth): void {
    this.monthYear.set(value);
  }

  triggerRefresh(): void {
    this.refreshTrigger.update((count) => count + 1);
  }
}
